"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _lodash = _interopRequireDefault(require("lodash"));
var _ShoppingCartActions = require("./ShoppingCartActions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultState = {
  cart: {},
  cartItems: [],
  fetchCartInProgress: false,
  fetchCartItemsInProgress: false,
  kittyAmount: 0,
  couponCart: null,
  updateItemInProgress: false,
  updateItemsInProgress: false,
  deleteItemInProgress: false
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'FETCH_CART_START':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          fetchCartInProgress: true
        });
      }
    case 'FETCH_CART_SUCCESS':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          cart: action.payload,
          fetchCartInProgress: false
        });
      }
    case 'RESET_CART_TO_DEFAULT':
      {
        return defaultState;
      }
    case 'ADD_TO_CART_START':
      {
        return _objectSpread({}, state);
      }
    case 'ADD_TO_CART_SUCCESS':
      {
        return _objectSpread({}, state);
      }
    case 'DELETE_ITEM_FROM_CART_START':
      {
        return _objectSpread({}, state);
      }
    case 'DELETE_ITEM_FROM_CART_SUCCESS':
      {
        return _objectSpread({}, state);
      }
    case 'UPDATE_KITTY_AMOUNT':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          kittyAmount: action.payload
        });
      }
    case 'FETCH_LINKED_COUPON_TO_CART_SUCCESS':
      {
        // For know we use only one coupon per cart.
        return _objectSpread(_objectSpread({}, state), {}, {
          couponCart: action.payload[0]
        });
      }
    case 'LINK_COUPON_TO_CART_SUCCESS':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          couponCart: action.payload
        });
      }
    case 'REMOVE_LINKED_COUPON_TO_CART_SUCCESS':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          couponCart: null
        });
      }
    case 'UPDATE_ITEM_START':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          updateItemInProgress: true
        });
      }
    case 'UPDATE_ITEM_SUCCESS':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          updateItemInProgress: false
        });
      }
    case 'UPDATE_ITEM_ERROR':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          updateItemInProgress: false
        });
      }
    case _ShoppingCartActions.FETCH_SHOPPING_CART_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchCartInProgress: true
      });
    case _ShoppingCartActions.FETCH_SHOPPING_CART_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        cart: action.payload,
        fetchCartInProgress: false
      });
    case _ShoppingCartActions.FETCH_SHOPPING_CART_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchCartInProgress: false
      });
    case _ShoppingCartActions.FETCH_SHOPPING_CART_ITEMS_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchCartItemsInProgress: true
      });
    case _ShoppingCartActions.FETCH_SHOPPING_CART_ITEMS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        cartItems: action.payload,
        fetchCartItemsInProgress: false
      });
    case _ShoppingCartActions.FETCH_SHOPPING_CART_ITEMS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetchCartItemsInProgress: false
      });
    case _ShoppingCartActions.UPDATE_SHOPPING_CART_ITEM_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        updateItemInProgress: true
      });
    case _ShoppingCartActions.UPDATE_SHOPPING_CART_ITEM_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        updateItemInProgress: false,
        cartItems: state.cartItems.map(function (item) {
          if (Number(item.id) === Number(action.payload.id)) {
            delete action.payload.salable_item;
            return _objectSpread(_objectSpread({}, item), action.payload);
          }
          return item;
        })
      });
    case _ShoppingCartActions.UPDATE_SHOPPING_CART_ITEM_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        updateItemInProgress: false
      });
    case _ShoppingCartActions.UPDATE_SHOPPING_CART_ITEMS_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        updateItemsInProgress: true
      });
    case _ShoppingCartActions.UPDATE_SHOPPING_CART_ITEMS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        updateItemsInProgress: false,
        cartItems: state.cartItems.map(function (item) {
          var updatedCartItem = _lodash.default.find(action.payloads, function (element) {
            return Number(element.id) === Number(item.id);
          });
          if (updatedCartItem) {
            delete updatedCartItem.salable_item;
            return _objectSpread(_objectSpread({}, item), updatedCartItem);
          }
          return item;
        })
      });
    case _ShoppingCartActions.UPDATE_SHOPPING_CART_ITEMS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        updateItemsInProgress: false
      });
    case _ShoppingCartActions.DELETE_SHOPPING_CART_ITEM_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        deleteItemInProgress: true
      });
    case _ShoppingCartActions.DELETE_SHOPPING_CART_ITEM_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        deleteItemInProgress: false,
        cartItems: state.cartItems.filter(function (item) {
          return Number(item.id) !== Number(action.id);
        })
      });
    case _ShoppingCartActions.DELETE_SHOPPING_CART_ITEM_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        deleteItemInProgress: false
      });
    default:
      return _objectSpread({}, state);
  }
}